import { Link } from "react-router-dom";

const CONTACT = "admin@pinscher-botb.com";

export function Footer() {
  return (
    <footer>
      <div className="container">
        <div className="foot-grid">
          <div className="foot-col">
            <Link to="/" className="brand">
              <img className="brand-mark" src="/pinscher-mark.png" alt="" width="50" height="33" />
              <span className="word">PINSCHER</span>
            </Link>
            <p>
              The AI red team for the human layer, built to train the blue team — autonomous vishing agents
              that pentest your people, then turn it into operator training.
            </p>
          </div>

          <div className="foot-col">
            <h4>Company</h4>
            <Link to="/#approach">Approach</Link>
            <Link to="/#defcon">Battle of the Bots</Link>
            <Link to="/#how">Technology</Link>
            <Link to="/investors">Investors</Link>
          </div>

          <div className="foot-col">
            <h4>Contact</h4>
            <a href={`mailto:${CONTACT}?subject=PINSCHER%20inquiry`}>{CONTACT}</a>
            <a href={`mailto:${CONTACT}?subject=PINSCHER%20%E2%80%94%20Investor%20inquiry`}>Investor inquiry</a>
            <span>By appointment · DEF CON 34</span>
          </div>
        </div>

        <div className="foot-bottom">
          <span>© {new Date().getFullYear()} PINSCHER. All rights reserved.</span>
          <span>Authorized adversarial research only.</span>
        </div>
      </div>
    </footer>
  );
}
